import { Markdown } from '@davidlloydleisure/common-js-frontend';
import React, { use } from 'react';

import { SiteContext } from 'src/context/site-context';
import { getBrandForBuildType } from 'src/helpers/brand-for-build-type';
import { getColorForOption } from 'src/helpers/color-option-helper';
import { onMarkdownLinkClick } from 'src/helpers/markdown-helper';
import { getBuildButtonStyle } from 'src/helpers/styling';
import type { HeaderBannerContent } from 'src/models/cms/common';
import { flex, globalBannerHeight } from 'src/styling/constants';
import mq from 'src/styling/media-queries';

import LinkButton from '../facilities/link-button';

type HeaderBannerProps = {
  content: HeaderBannerContent;
};

const HeaderBanner: React.FC<HeaderBannerProps> = ({ content }) => {
  const { buildType, language } = use(SiteContext);
  if (!content) {
    return null;
  }

  const button = content.button;

  return (
    <div
      css={mq([
        flex.rowCentered,
        {
          backgroundColor: getColorForOption(content.bannerBackgroundColor),
          maxHeight: [globalBannerHeight.mobile, globalBannerHeight.default],
          minHeight: [globalBannerHeight.mobile, globalBannerHeight.default],
          padding: ['1rem 0.5rem', '1rem 2rem'],
        },
      ])}
    >
      <div css={mq({ flex: 1, fontSize: ['1rem', '1.25rem'], p: { margin: 0 } })}>
        <Markdown
          markdownText={content.text}
          colorOverride={getColorForOption(content.bannerTextColor)}
          brand={getBrandForBuildType(buildType)}
          onLinkClick={onMarkdownLinkClick(buildType, language, 'Header Banner')}
        />
      </div>

      {button.showButton && (
        <div css={{ padding: '0.25rem' }}>
          <LinkButton
            buttonText={button.buttonText}
            buttonLink={button.buttonLink}
            buttonType="button-header"
            buttonStyle={getBuildButtonStyle(buildType, button)}
            goToGlobal={button.goToGlobal}
          />
        </div>
      )}
    </div>
  );
};

export default HeaderBanner;
